import React,{useEffect,useState} from 'react'
import './index.less'
import {Input} from 'antd-mobile'
import { connect,useHistory } from 'umi';
function index(props:any) {
    const {dispatch,setSearchState} = props
    const [value,setValue] = useState('')
    const history = useHistory()
    // useEffect(() => {
    //     document.getElementsByName('searchInput')[0].focus()
    // }, [])
    
    // const inputOnBlur = () => {
    //     setPlaceholder('Search ...')
    // }
    // const inputOnFocus = () => {
    //     setPlaceholder('')
    // }
    // onBlur={inputOnBlur } onFocus={inputOnFocus }
    return (
        <div className='searchDialog'>
            <div onClick={(e)=>{
                e.stopPropagation()
            }} className='searchDialog_header'>
            <Input onEnterPress={()=>{
                document.body.style.overflow = '';
                document.getElementsByTagName('html')[0].style.overflow = ''
                setSearchState(false)
                if(history.location.pathname == '/s'){
                    history.replace({pathname:'/s',query:{value:value,categoryId:0,categoryName:'All Categories',k:value}})
                    window.location.reload()
                }else{

                    history.push({pathname:'/s',query:{value:value,categoryId:0,categoryName:'All Categories',k:value}})
                }
            }} className='searchInput' autoFocus={true}  placeholder='Search ...'
                onChange={(value)=>setValue(value)}
            ></Input>
            <div onClick={()=>{
                document.body.style.overflow = '';
                document.getElementsByTagName('html')[0].style.overflow = ''
                setSearchState(false)
                if(history.location.pathname == '/s'){
                    history.replace('/s?categoryId=0&value='+ value + '&k='+ value + '&categoryName=All Categories')
                    window.location.reload()
                }else{
                    history.push('/s?categoryId=0&value='+ value + '&k='+ value + '&categoryName=All Categories')
                }
                
            }} className='searchAll'>
                Search
            </div>
            </div>
            <div onClick={()=>{
                document.body.style.overflow = '';
                document.getElementsByTagName('html')[0].style.overflow = ''
                setSearchState(false)
            }} className='searchDialog_main'>

            </div>
        </div>
    )
}

export default connect(() => {
    return {
      
    };
  })(index);

